// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.retail-adjustments-table.small-table,
.retail-adjustments-table.small-table table {
  max-height: 225px;
}

.retail-adjustments-table.large-table,
.retail-adjustments-table.large-table table {
  max-height: 240px;
}

.retail-adjustments-table thead {
  position: sticky;
  top: -1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Report/ReportLayout/styles.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".retail-adjustments-table.small-table,\n.retail-adjustments-table.small-table table {\n  max-height: 225px;\n}\n\n.retail-adjustments-table.large-table,\n.retail-adjustments-table.large-table table {\n  max-height: 240px;\n}\n\n.retail-adjustments-table thead {\n  position: sticky;\n  top: -1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
